export default "__VITE_ASSET__B64Uj37L__"